import { FC, memo, useCallback, useMemo } from "react";
import { PropertySubsectionTitle } from "../../property-performance-report/components/property-subsection-title";
import { PropertyTeaserType } from "@/store/properties/types";
import { ReactComponent as AgreeHands } from "assets/agree-hands.svg";
import { Container } from "react-bootstrap";
import { useTranslate } from "@tolgee/react";
import { Videos } from "new-architecture/components/videos";
import { useTrackTeaserProductVideoOpenedMutation } from "api/analitics";

import styles from "./style.module.scss";

type Props = {
  property: PropertyTeaserType;
};

export const PropertyPartner: FC<Props> = memo(({ property }) => {
  const { text, image, videos } = useMemo(() => {
    const { securityAndRoles, sectionAssets } = property;
    const { roles, aboutThePartner } = securityAndRoles;
    const { partner: partnerVideos } = sectionAssets || {};
    const { text, image } = aboutThePartner || {};


    return { roles, text, image, videos: partnerVideos || [] };
  }, [property]);

  const { t: tOpportunityDetailPagePartner } = useTranslate('opportunity_detail_page.partner');

  const [trackProductVideoOpened] = useTrackTeaserProductVideoOpenedMutation();
  const onOpenVideo = useCallback((videoUrl: string) => {
    trackProductVideoOpened({
      opportunity: property.name,
      opportunityId: property._id,
      productVideoUrl: videoUrl
    });
  }, [trackProductVideoOpened, property]);

  return (
    <Container className='mt-4'>
      {(text?.length || image) &&
        <div className={styles['wrapper__box']}>
          <PropertySubsectionTitle
            icon={<AgreeHands />}
            title={tOpportunityDetailPagePartner('opportunity_detail_page.partner')}
          />
          <Videos videos={videos} onOpenVideo={onOpenVideo} />
          {image && (
            <div className={styles["wrapper__about-the-partner-image-container"]}>
              <img alt={"Partner logo"} src={image} />
            </div>
          )}
          {text && (
            <div
              className={styles["wrapper__about-the-partner-wysiwyg-container"]}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )}
        </div>
      }
    </Container>
  );
});

PropertyPartner.displayName = "PropertyPartner";